import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DuplicatePersonTable from "../../Presentational/DuplicatePerson/DuplicatePersonTable";
const searchArgs = {
    merged: false,
    ignored: true,
};
const DuplicatePersonIgnoredTab = ({ id, counterState, }) => {
    const actions = [
        {
            id: 2,
            name: "Unignore",
            icon: "check",
            title: "Unignore",
        },
    ];
    return (_jsx(DuplicatePersonTable, { actions: actions, search: Object.assign(Object.assign({}, searchArgs), { ruleSetIds: [id] }), noReviewAndMergeAllowed: true, counterState: counterState }));
};
export default DuplicatePersonIgnoredTab;
